import { mainColor, UNIT } from '../../constants';

export const styles = () => ({
  root: {
    flexGrow: 1
  },
  table: {},
  button: {
    backgroundColor: mainColor.colorWhite
  },
  progress: {
    margin: UNIT * 5,
    textAlign: 'center',
    color: mainColor.secondaryColor,
    alignSelf: 'center'
  },
  heading: {
    fontSize: UNIT * 0.9375,
    fontWeight: 'bolder',
    color: mainColor.colorBlackLight,
    maxWidth: UNIT * 8.375
  },
  lastHeading: {
    fontSize: UNIT * 0.9375,
    padding: UNIT * 0.5625,
    fontWeight: 'bolder',
    color: mainColor.colorBlackLight
  },
  valueC: {
    fontSize: UNIT * 0.9375,
    flexBasis: '19%',
    flexShrink: 0,
    padding: UNIT * 1.0625,
    textAlign: 'center',
    color: 'black !important'
  },
  graph: { 
    padding: 20,
    border: 'solid',
    borderRadius: 16,
    borderWidth: 0.8,
    borderColor: mainColor.colorGray 
  },
  headingTab: {
    fontSize: UNIT * 0.9375,
    fontWeight: 'bolder',
    color: mainColor.colorBlackLight,
    maxWidth: UNIT * 6.25
  }
});
